import { render } from "./DishCardfree.vue?vue&type=template&id=6f90a55b&scoped=true"
import script from "./DishCardfree.vue?vue&type=script&lang=js"
export * from "./DishCardfree.vue?vue&type=script&lang=js"

import "./DishCardfree.vue?vue&type=style&index=0&id=6f90a55b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f90a55b"]])

export default __exports__